import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import siteConfig from '../data/siteConfig.json';
import { Link } from 'react-router-dom';

const About = () => {
  const { t } = useLanguage();

  return (
    <div className="bg-white min-h-screen">
      <div className="bg-glass-dark text-white py-20 pb-32">
        <div className="container mx-auto px-6 max-w-7xl">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">{t('aboutPage.title')}</h1>
        </div>
      </div>

      <div className="container mx-auto px-6 max-w-7xl -mt-16">
        <div className="bg-white rounded-3xl shadow-xl border border-slate-100 p-8 md:p-12 flex flex-col lg:flex-row gap-12">
          <div className="lg:w-1/2">
            <img 
              src={siteConfig.images.aboutShop}
              alt="Auto Glass Shop" 
              className="rounded-2xl w-full h-full object-cover min-h-[300px]"
            />
          </div>
          <div className="lg:w-1/2 flex flex-col justify-center">
            <h2 className="text-3xl font-bold text-slate-900 mb-6">Local Experts in Dorval</h2>
            <div className="space-y-6 text-lg text-slate-600 leading-relaxed">
              <p>{t('aboutPage.p1')}</p>
              <p>{t('aboutPage.p2')}</p>
            </div>
            
            <div className="mt-10 grid grid-cols-2 gap-6">
              <div className="bg-slate-50 p-6 rounded-xl border border-slate-100">
                <div className="text-3xl font-bold text-glass-blue mb-2">10+</div>
                <div className="text-sm font-semibold text-slate-800 uppercase tracking-wider">Years Experience</div>
              </div>
              <div className="bg-slate-50 p-6 rounded-xl border border-slate-100">
                <div className="text-3xl font-bold text-glass-blue mb-2">5k+</div>
                <div className="text-sm font-semibold text-slate-800 uppercase tracking-wider">Happy Clients</div>
              </div>
            </div>

            <div className="mt-10">
               <Link to="/contact" className="bg-glass-blue text-white px-8 py-4 rounded-lg font-bold transition-all hover:bg-blue-600 inline-block">
                {t('common.contactUs')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
